import { render, staticRenderFns } from "./SetupButton.vue?vue&type=template&id=00197a83&scoped=true&"
import script from "./SetupButton.vue?vue&type=script&lang=ts&"
export * from "./SetupButton.vue?vue&type=script&lang=ts&"
import style0 from "./SetupButton.vue?vue&type=style&index=0&id=00197a83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00197a83",
  null
  
)

export default component.exports